var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEditMediaWhitepoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.editMediaWhitepoint{fill:currentColor;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "editMediaWhitepoint",
    d: "M14.78,6.22l-5-5C9.64,1.08,9.45,1,9.25,1h-5.5C2.23,1,1,2.24,1,3.75v8.5C1,13.77,2.23,15,3.75,15h8.51 c1.52,0,2.75-1.23,2.75-2.75v-5.5C15,6.55,14.92,6.36,14.78,6.22z M10,3.56L12.44,6H10V3.56z M12.25,13.5h-8.5 c-0.69,0-1.25-0.56-1.25-1.25v-8.5c0-0.69,0.56-1.25,1.25-1.25H8.5v4.25c0,0.41,0.34,0.75,0.75,0.75h4.25v4.75 C13.5,12.94,12.94,13.5,12.25,13.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEditMediaWhitepoint);
export default __webpack_public_path__ + "static/media/icon_edit-media-whitepoint.5d2e3e90b49af6b2bbfa5ad814cbc7ce.svg";
export { ForwardRef as ReactComponent };